require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

var isPrototypeOf = require('../../internals/object-is-prototype-of');

var method = require('../array/virtual/flat');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.flat;
  return it === ArrayPrototype || isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.flat ? method : own;
};